import { render } from "./PWAInstallPrompt.vue?vue&type=template&id=3bed14bc&scoped=true"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"

import "./PWAInstallPrompt.vue?vue&type=style&index=0&id=3bed14bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bed14bc"]])

export default __exports__